module.exports = __webpack_public_path__ + "img/2.0ef1e4fc.svg";